<app-carousel
    [typeSearch]="'Employee'"
></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <div class="row mt-5 mb-2">
            <div class="col-md-6 col-sm-6 col-12">
                <h5 class="mt-0 mb-2">
                    <i class="fa-regular fa-address-card"></i>
                    {{resume().name}}
                </h5>
            </div>
            <div class="col-md-6 col-sm-6 col-12">
                <div class="text-end">
                    <button (click)="goBack()" type="button" class="btn btn-secondary me-2">
                        <i class="fa-solid fa-arrow-left"></i>
                        Volver atras
                    </button>
                    <button type="button" class="btn btn-secondary me-2" data-bs-toggle="modal" data-bs-target="#modalCompartir">
                        <i class="fa-solid fa-share-from-square"></i>
                        Compartir
                    </button>
                    <button type="button" class="btn btn-primary" (click)="printResume()">
                        @if(!isLoading()){
                            <i class="fa-solid fa-print"></i>
                            Imprimir
                        }@else {
                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Cargando...
                        }
                    </button>
                </div>
            </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row">
            <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-auto">
                                @if (candidatePersonalInfo().photoFileId) {
                                    <img 
                                    [src]="API_URL+'/File/ViewFile/' + candidatePersonalInfo().photoFileId"
                                    alt="Compania" class="img-fluid" style="max-width: 120px;" />
                                }@else {
                                    <img src="assets/Images/user.png" 
                                    alt="Compania" class="img-fluid" style="max-width: 120px;" />
                                }
                            </div>
                            <div class="col">
                                <h3 class="text-primary mt-2 mb-1">
                                    {{candidatePersonalInfo().firstName}}  {{candidatePersonalInfo().lastName}}
                                </h3>
                                <h5 class="text-secondary mt-1 mb-1">
                                    <i class="fa-regular fa-envelope"></i>
                                    {{candidatePersonalInfo().email}}
                                </h5>
                                <h5 class="text-secondary mt-1 mb-1">
                                    <i class="fa-solid fa-mobile-screen"></i>
                                    {{candidatePersonalInfo().cellPhone  | mask: '(000)-000-0000'}}
                                </h5>
                                <h5 class="text-secondary mt-1 mb-1">
                                    <i class="fa-solid fa-location-dot"></i>
                                    {{candidatePersonalInfo().city}}, {{candidatePersonalInfo().countryName}}
                                </h5>
                            </div>
                        </div>
                        <h5 class="text-primary mt-1 mb-1">
                            Acerca de
                        </h5>
                        <hr class="mt-3 mb-3" />
                        <div class="row">
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <label class="text-secondary">Edad</label>
                                <div class="mb-2">
                                    {{personAge()}}
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <label class="text-secondary">Teléfono</label>
                                <div class="mb-2">
                                   {{candidatePersonalInfo().cellPhone | mask: '(000)-000-0000'}}
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <label class="text-secondary">Nacionalidad</label>
                                <div class="mb-2">
                                    {{candidatePersonalInfo().nationality}}
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <label class="text-secondary">Vehículo</label>
                                <div class="mb-2">
                                    {{candidatePersonalInfo().hasVehicle ? 'Si' : 'No'}}
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <label class="text-secondary">Licencia</label>
                                <div class="mb-2">
                                    {{candidatePersonalInfo().hasDriverLicense ? 'Si' : 'No'}}
                                </div>
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <label class="text-secondary">Dirección</label>
                                <div class="mb-2">
                                   {{candidatePersonalInfo().address}}
                                </div>
                            </div>
                        </div>
                        <h5 class="text-primary mt-1 mb-1">
                            Experiencia Laboral
                        </h5>
                        <hr class="mt-3 mb-3" />
                        @for (item of employments(); track item.id) {
                            <div class="card mb-1">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <label class="text-secondary">Cargo desempeñado</label>
                                            <div class="mb-2">
                                                {{item.position}}
                                            </div>
                                            <label class="text-secondary">Compañia</label>
                                            <div class="mb-2">
                                                {{item.company}}
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <label class="text-secondary">Periodo</label>
                                            <div class="mb-2">
                                                {{item.startDate | date : 'dd/MM/yyyy'}} al  {{item.endDate | date : 'dd/MM/yyyy'}}
                                            </div>
                                            <label class="text-secondary">Rango Salarial</label>
                                            <div class="mb-2">
                                                {{item.salaryExpectation}}
                                            </div>
                                        </div>
                                    </div>
                                    <p class="text-justify">
                                        {{item.responsibility}}
                                    </p>
                                </div>
                            </div>
                        }
                        <h5 class="text-primary mt-1 mb-1">
                            Referencias
                        </h5>
                        <hr class="mt-3 mb-3" />
                        @for (item of references(); track item.id) {
                            <div class="card mb-1">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <label class="text-secondary">Nombre</label>
                                            <div class="mb-2">
                                                {{item.firstName}} {{item.lastName}}
                                            </div>
                                            <label class="text-secondary">Compañia</label>
                                            <div class="mb-2">
                                                {{item.company}}
                                            </div>
                                            <label class="text-secondary">Posición</label>
                                            <div class="mb-2">
                                                {{item.position}}
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <label class="text-secondary">Teléfono</label>
                                            <div class="mb-2">
                                                {{item.phone | mask: '(000)-000-0000'}}
                                            </div>
                                            <label class="text-secondary">Correo electrónico</label>
                                            <div class="mb-2">
                                                {{item.email}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="text-primary mt-1 mb-1">
                            Educación
                        </h5>
                        <hr class="mt-2 mb-2" />

                        @for (item of educations(); track item.id) {
                            <div>
                                <h5 class="mt-0 mb-1">
                                    <span class="badge rounded-pill text-bg-primary">
                                        @if(item.endDate){
                                            {{item.startDate | date : 'yyyy'}}-{{item.endDate | date : 'yyyy'}}
                                        }@else {
                                            {{item.startDate | date : 'yyyy'}}
                                        }
                                    </span>
                                    {{item.educationLevel}}
                                </h5>
                                <strong>{{item.resumeEducationStatus}}</strong>
                                <br />
                                {{item.institution}} 
                            </div>
                        }

                        <h5 class="text-primary mt-3 mb-1">
                            Certificaciones
                        </h5>
                        <hr class="mt-2 mb-2" />
                        @for (item of certifications(); track item.id) {
                            <div class="mb-3">
                                <h5 class="mt-0 mb-1">
                                    {{item.name}}
                                </h5>
                                <strong>Vigencia</strong>: 
                                @if (item.expirationDate) {
                                    {{item.completionDate | date : 'dd/MM/yyyy'}} al {{item.expirationDate | date : 'dd/MM/yyyy'}}
                                }@else {
                                    Sin Fecha de Expiración
                                }
                                 <br />
                               {{item.institution}}
                            </div>
                        }
                     
                        <h5 class="text-primary mt-4 mb-1">
                            Habilidades
                        </h5>
                        <hr class="mt-2 mb-2" />
                        <ul class="list-group">
                            @for (item of skills(); track item.id) {
                                <li class="list-group-item d-flex justify-content-between align-items-start">
                                    <div class="ms-0 me-auto">
                                        Habildad {{ item.skillName }}
                                    </div>
                                    <span class="badge text-bg-primary rounded-pill">{{item.skillLevel}}</span>
                                </li>
                            }
                        </ul>

                        <h5 class="text-primary mt-4 mb-1">
                            Idiomas
                        </h5>
                        <hr class="mt-3 mb-3" />
                        <ul class="list-group">
                            @for (item of languages(); track item.id) {
                                <li class="list-group-item d-flex justify-content-between align-items-start">
                                    <div class="ms-0 me-auto">
                                        Idioma {{ item.languageName }}
                                    </div>
                                    <span class="badge text-bg-primary rounded-pill">{{item.languageLevel}}</span>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalDocumento" tabindex="-1" aria-labelledby="modalDocumentoLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalDocumentoLabel">
                    Documento
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="ratio ratio-4x3">
                    <iframe id="docPrintDocumento"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>